import { Component, OnInit, Input, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DialogBoxComponent } from '../dialog-box/dialog-box.component';
import * as echarts from "echarts";
import { DashboardService } from 'src/app/services/dashboard.service';
import { CdkOverlyayService } from '../custom-overlay/cdk-overlyay.service';
import { TemplateDropdownComponent } from '../custom-overlay/template-dropdown/template-dropdown.component';
// import { UserLoginService } from 'src/app/user-login/user-login.service';
import { formatDate, KeyValue } from '@angular/common';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { UserOptions } from 'jspdf-autotable';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ValidatorFn, FormGroup, ValidationErrors, UntypedFormControl, UntypedFormBuilder } from '@angular/forms';
import { ErrorMsgHandler } from 'src/app/shared/errormanagement/handleerror';
import { TimeZoneService } from 'src/app/services/time-zone.service';
import * as moment from 'moment-timezone';
import { SharedService } from 'src/app/services/shared.service';
import { Metropolis_ExtraLight, Metropolis_Light,Metropolis_LightItalic,Metropolis_Medium,Metropolis_Regular,Metropolis_SemiBold} from 'src/assets/fonts/font';


interface jsPDFWithPlugin extends jsPDF {
  autoTable: (options: UserOptions) => jsPDF;
}

@Component({
  selector: 'app-dashboard-widget',
  templateUrl: './dashboard-widget.component.html',
  styleUrls: ['./dashboard-widget.component.scss']
})
/*
  according to the widget type and name sent from parent component 
  from_date from metadata and to_date as current_date - data is populated and widget is rendered
  chart render options and data are get from api and combined here
*/
/*
---values sent from parent component(dashboard/studio preview)
widgetType(table/chart),widget name  
dialogWidth - width % of the full screen dialog
moreOptionEnable - in studio preview, more options should not be shown
---variables used
widgetDetail - data and otherdetails of widget subscribed from api
chartOption -  to build echart
selectedColorPalette - selected colors, to restore that color after date filter is applied
moreOptionState -  show/hide more options(dayfiter,colorpalatee, dull screen and download)
fromDate - date filter from date - default value
toDate - date filter to date - default value
*/
export class DashboardWidgetComponent implements OnInit, OnDestroy {

  handledashboardwidgetnodata = new ErrorMsgHandler()
  errorhandledashboardwidget = new ErrorMsgHandler()

  // details from parent component
  @Input() widgetType: any;
  @Input() widgetName: string;
  @Input() widgetImg: string;
  @Input() dialogWidth: any;
  @Input() moreOptionEnable: boolean;
  @Input() CustomFilterSub: string;
  @Input() filterDays: number;
  @Input() defaultDate: any;
  @Input() noOfDays
  @Input() spinner=false
  @Input() isCollectiveDashboard=false
  selectedColorIndex:number = 10
  widgetDetail: any;
  chartOption: any;
  selectedColorPalette: string;
  moreOptionState = false;
  defaultColors = this.sharedService.metaData.dashboard.dashboard_landing.colors
  moreoptiontitles = this.sharedService.metaData.dashboard.dashboard_landing.widgetmenu

  customTimeRange = {
    from: "",
    to: "",
    valid: false
  }

  maxdate = this.timeZoneService.getcurrentuserTime().format(this.dashboardService.timeformat)
  mindate = this.timeZoneService.toUserTimeZone(this.sharedService.timeRange.event_time_range[0]).format('YYYY-MM-DD HH:mm:ss');

  defaultTimeRange = {
    from: this.timeZoneService.getcurrentuserTime().clone().startOf('D').format('YYYY-MM-DD HH:mm'),
    to: this.timeZoneService.getcurrentuserTime().format('YYYY-MM-DD HH:mm')
  }


  timeRange = this.fb.group({
    fromDate: new UntypedFormControl(this.defaultTimeRange.from),
    toDate: new UntypedFormControl(this.defaultTimeRange.to),
  }, { validators: [this.creatDateRangeValidator()] });

  selectTime = this.fb.group({
    fromDate: new UntypedFormControl(this.defaultTimeRange.from),
    toDate: new UntypedFormControl(this.defaultTimeRange.to),
  }, { validators: [this.creatDateRangeValidator()] });


  dialogRef: any;
  previewRef: any;
  widgetRequestObj = {
    // 'hosts': [''],
    // 'default': true,
    'widget_type': '',
    // 'widget_name': '',
    'timeRange': [''],
    "userTimeZone":this.sharedService.timeZone
  }
  defaultState: boolean = false;
  spinnerState: boolean = false;
  $destroy: Subject<boolean> = new Subject();

  widgetrequestinstance: any;

  constructor(public matDialog: MatDialog,
    public cdkverlayDialog: CdkOverlyayService, private cdf: ChangeDetectorRef, private fb: UntypedFormBuilder,
    private dashboardService: DashboardService, private sharedService: SharedService,
    private timeZoneService: TimeZoneService
  ) { }

  ngOnInit(): void {

    this.spinnerState=this.spinner
    // console.log(this.spinnerState)

    // this.selectTime.valueChanges.subscribe(val=>{
      // console.log(val)
    // })

   

    // console.log(this.selectTime.value)


//console.log(this.defaultDate)
    // console.log("Subtitle",this.CustomFilterSub)
    // console.log("zone",this.dashboardService.userTimeZone)
    // console.log(this.widgetRequestObj)
    // console.log(this.sharedService.timeZone)
    this.setTimeRange(this.sharedService.metaData.dashboard.dateFilter_default.default_fromDt);
    this.defaultState = true;
    this.resetdateinput();

    this.dashboardService.getdashboardlanding.isProgress$.pipe(takeUntil(this.$destroy)).subscribe(progress => {
      if (!progress) {
        if (this.dashboardService.dashboardLandingData['isData']) {
          let val=this.dashboardService.dashboardLandingData['widgets'][this.widgetName]
          val.widgetDetails["timeRange"]=this.defaultDate
          val.widgetDetails["noOfDays"]=this.noOfDays
          // this.setWidgetDetails(this.dashboardService.dashboardLandingData['widgets'][this.widgetName])
          this.setWidgetDetails(val)
        } else {
          this.setErrormsg(this.dashboardService.dashboardLandingData)
        }
      } else {
        this.spinnerState = true
      }
    })
  }
  //used in .html, to display the keys of an object as  the order it comes from api
  originalOrder = (a: KeyValue<number, string>, b: KeyValue<number, string>): number => {
    return 0;
  }
  creatDateRangeValidator(): ValidatorFn {
    return (form: FormGroup): ValidationErrors | null => {
      const err = {}
      const start = this.timeZoneService.setcurrentuserTime(form.get("fromDate").value);
      const end = this.timeZoneService.setcurrentuserTime(form.get("toDate").value);

      if (start && end) {
        const validyear = start.year() > 2000 && end.year() > 2000;
        if (!validyear) {
          err['yearrange'] = true;
        }
        const isRangeValid = (end.unix() - start.unix() > 0) && (end || start) < this.timeZoneService.getcurrentuserTime();

        if (!isRangeValid) {
          err['dateRange'] = true;
        }
      }
      return err;
    }
  }

  resetdateinput() {
    this.selectTime.controls.fromDate.reset(this.defaultTimeRange.from);
    this.selectTime.controls.toDate.reset(this.defaultTimeRange.to);
    this.customTimeRange.valid = false
  }
  //load widget details, chartOption and chart data according to from and to dates
  load_widgetData(loadDataType, noOfDays?, clicktype?) {
//console.log("Load_WidgetData")
    let platform=""
    this.sharedService.$selectedDashboardLabel.pipe(takeUntil(this.$destroy)).subscribe((val:any)=>{
      platform=val?.platform;
    
    })
//console.log("selectdashboard========",platform)
    
    this.defaultState = false;
    // this.widgetRequestObj["refresh"] = false;
    //set from date, to date according to the selected option like yesterday / last 7 days....
    if (clicktype && clicktype == 'relativetime') {
      this.resetdateinput();
    }

    this.setTimeRange(noOfDays);
    if (!this.timeRange.errors) {
      if (clicktype && clicktype == 'customtime') {
        this.customTimeRange.from = this.selectTime.controls.fromDate.value;
        this.customTimeRange.to = this.selectTime.controls.toDate.value;
        this.customTimeRange.valid = true
      }

      this.handledashboardwidgetnodata.status = false;
      this.errorhandledashboardwidget.status = false;
      this.widgetRequestObj["platform"]=platform
      if (loadDataType == "refresh") {
        this.selectedColorIndex = 10
        this.resetdateinput();
        this.selectedColorPalette = ""
        this.widgetRequestObj["refresh"] = true;
        // this.widgetRequestObj["widget_key"] = this.widgetName
        this.widgetRequestObj['widgetkeys'] = [this.widgetName];
      } else {
        this.widgetRequestObj["refresh"] = false;
        this.widgetRequestObj['widgetkeys'] = [this.widgetName];
        // this.widgetRequestObj['time_zone_difference']=this.timeZoneService.getcurrentuserTime().utcOffset() * 60
        // this.widgetRequestObj["widget_key"] = this.widgetName + this.timeZoneService.toUtcTimeZonefromUser(this.timeRange.controls.toDate.value).format('YYYY-MM-DD')
      }

      if (this.previewRef) {
        this.previewRef.close()
      }
      if (this.dialogRef) {
        this.dialogRef.close()
      }
      if (this.selectTime.errors) return
      this.widgetDetail = null;
      this.widgetRequestObj['widget_type'] = this.widgetType
      // this.widgetRequestObj['widget_name'] = this.widgetName;
      this.widgetRequestObj['widgetkeys'] = [this.widgetName];
      // this.widgetRequestObj['hosts'] = ['all']

      // console.log("->",this.timeRange.controls.toDate.value)
      // console.log("->",this.timeZoneService.toUtcTimeZonefromUser(this.timeRange.controls.toDate.value))
      // console.log("->",this.timeZoneService.toUtcTimeZonefromUser(this.timeRange.controls.toDate.value).format(this.dashboardService.timeformat))

      this.widgetRequestObj['timeRange'] = [this.timeZoneService.toUtcTimeZonefromUser(this.timeRange.controls.fromDate.value).format(this.dashboardService.timeformat), this.timeZoneService.toUtcTimeZonefromUser(this.timeRange.controls.toDate.value).format(this.dashboardService.timeformat)]
      
      this.widgetRequestObj['time_zone_difference']=this.timeZoneService.getcurrentuserTime().utcOffset() * 60
      // this.widgetRequestObj['userTimeZone']=this.sharedService.timeZone
    
//console.log("Widget Req obj --->",this.widgetRequestObj)


      // Table widget
      if (this.widgetType == 'Table') {
//console.log("table")
        this.spinnerState = true
        this.widgetrequestinstance = this.dashboardService.getwidgetTable()
        this.widgetrequestinstance.postrequest(this.widgetRequestObj)
          .pipe(takeUntil(this.$destroy))
          .subscribe(res => {
            // console.log("load_widgetData=table==",res);
        
            let val=Object.values(res['res_obj']['widgets'])[0]
            
            val["widgetDetails"]["timeRange"]=[this.timeZoneService.toUtcTimeZonefromUser(this.timeRange.controls.fromDate.value).format(this.dashboardService.timeformat), this.timeZoneService.toUtcTimeZonefromUser(this.timeRange.controls.toDate.value).format(this.dashboardService.timeformat)]

            val["widgetDetails"]["noOfDays"]=this.filterDays

            
            
            this.setWidgetDetails(val);
          },
            (err) => {
              // this.spinnerState = false;
              this.setErrormsg(err);
            },
            () => {
              this.spinnerState = false;
            });

      }
      // Chart widget
      if (this.widgetType == 'Chart') {
//console.log("Chart")
        this.chartOption = {};
        this.spinnerState = true;
//console.log(this.widgetrequestinstance)
        this.widgetrequestinstance = this.dashboardService.getwidgetchart()
//console.log(this.widgetrequestinstance)
        this.widgetrequestinstance.postrequest(this.widgetRequestObj)
          .pipe(takeUntil(this.$destroy))
          .subscribe((res: any) => {
//console.log("load_widgetData===",res);
            let val=Object.values(res['res_obj']['widgets'])[0]
//console.log({val})
            val["widgetDetails"]["timeRange"]=[this.timeZoneService.toUtcTimeZonefromUser(this.timeRange.controls.fromDate.value).format(this.dashboardService.timeformat), this.timeZoneService.toUtcTimeZonefromUser(this.timeRange.controls.toDate.value).format(this.dashboardService.timeformat)]
            val["widgetDetails"]["noOfDays"]=this.filterDays
            this.setWidgetDetails(val)
          },
            (err) => {
              this.setErrormsg(err);
            },
            () => {
              this.spinnerState = false;
            }
          )
          // .catch((err) => {
          //   this.spinnerState = false;
          // })
      }
    }
  }

  //set timerange or form control
  setTimeRange(noOfDays: any) {
    if (noOfDays && noOfDays[2] >= 0) {
      this.filterDays = noOfDays[2];
      this.timeRange.controls.fromDate.patchValue(this.dashboardService.timeRangeCalc(noOfDays)[0]);
      this.timeRange.controls.toDate.patchValue(this.dashboardService.timeRangeCalc(noOfDays)[1]);
    } else {
      this.filterDays = undefined;
      this.timeRange.controls.fromDate.patchValue(this.timeZoneService.setcurrentuserTime(this.selectTime.controls.fromDate.value).format('YYYY-MM-DD HH:mm'));
      this.timeRange.controls.toDate.patchValue(this.timeZoneService.setcurrentuserTime(this.selectTime.controls.toDate.value).format('YYYY-MM-DD HH:mm'));
    }
  }
  // for open & close more option click
  moreOptions_click() {
    this.moreOptionState = true // !this.moreOptionState;
  }
  closeOptions_click() {
    if (this.dialogRef) {
      this.dialogRef.close()
    }
  }
  //open moreoptions in overlay

  openOverlay_moreoptions_click(template, origin): void {
    this.moreOptionState = true
    let config = {
      // width: "225px",
      // height: "29px",
      data: {

        "template": template,
      }
    }
    this.dialogRef = this.cdkverlayDialog.dashboard_moreoptions(config, TemplateDropdownComponent, origin);
  }

  open_overlay(template, origin,){
    let config = {
      width: '5%',
      // backdropClass: 'cdk-overlay-dark-backdrop',
      data: {

        "template": template,
      }
    }
    this.previewRef = this.cdkverlayDialog.openPreview(config, TemplateDropdownComponent, origin);

    if (!this.customTimeRange.valid) {
      this.resetdateinput();
    }

    this.previewRef.$closed.subscribe(() => {
      if (this.selectTime.errors) {
        this.resetdateinput();
      }
    })
  }
  //open color palatte and datefilter in overlay
  // openOverlay_click(template, origin, overlaytype): void {
  //   if (!(this.widgetType == 'Table' && overlaytype == 'colorpalate')) {
  //     if ((!this.handledashboardwidgetnodata.status && this.widgetDetail.apply_default_timerange) || (overlaytype == "datefilter" && this.widgetDetail.apply_default_timerange)) {
  //       let config = {
  //         width: '5%',
  //         // backdropClass: 'cdk-overlay-dark-backdrop',
  //         data: {

  //           "template": template,
  //         }
  //       }
  //       this.previewRef = this.cdkverlayDialog.openPreview(config, TemplateDropdownComponent, origin);

  //       if (!this.customTimeRange.valid) {
  //         this.resetdateinput();
  //       }

  //       this.previewRef.$closed.subscribe(() => {
  //         if (this.selectTime.errors) {
  //           this.resetdateinput();
  //         }
  //       })
  //     }
  //   }
  // }

  openOverlay_datefilter(template, origin,overlaytype):void {
    if(this.widgetDetail.apply_default_timerange){
      this.open_overlay(template,origin)
    }
  }

  openOverlay_color_palette(template, origin, overlaytype):void {
    if(this.widgetDetail.is_color_palette_enable){
      this.open_overlay(template,origin)
    }
  }
  //updates chart color for full screen option
  colorPalatte_click(selectedColor,index:number) {
//console.log("colorPalatte_click================",selectedColor,index)
    this.selectedColorIndex=index
    const chartDom = document.getElementById(this.widgetName);
    // let myChart = echarts.init(chartDom);
    let myChart 
    

    if (chartDom) {
      let existingChart = echarts.getInstanceByDom(chartDom);
      
      if (existingChart) {
        myChart = existingChart;
      } else {
        myChart = echarts.init(chartDom);
      }
  
    }
    let options = myChart.getOption();

//console.log(this.widgetDetail.chart_type,"$$")
//console.log(selectedColor,"$$")



    if (this.widgetDetail.chart_type == 'custompolarheatmap'|| this.widgetDetail.chart_type == 'heatmap' || this.widgetDetail.chart_type == 'custompolarheatmap2') {
      // selectedColor = ['#FFFFFF'].concat(selectedColor);
      myChart.setOption({
        visualMap: {
          inRange: {
            color: selectedColor
          }
        }
      });
      this.chartOption.visualMap.inRange.color = selectedColor;
    } else if (this.widgetDetail.chart_type == 'polarbar') {
      options.series[1].itemStyle.color = selectedColor[5];
      options.series[3].itemStyle.color = selectedColor[3];
      myChart.setOption(options);
      this.chartOption = options;
    } else if (this.widgetDetail.chart_type == 'large_area_chart') {
      options.series[0].itemStyle.color = selectedColor[5];
      // options.series[0].areaStyle.color = new echarts.graphic.LinearGradient(0, 0, 0, 1, [
      //   {
      //     offset: 0,
      //     color: selectedColor[2]
      //   },
      //   {
      //     offset: 1,
      //     color: selectedColor[0]
      //   }
      // ])
      options.series[0].areaStyle.color = selectedColor[0];
      myChart.setOption(options);
      this.chartOption = options;
    }
    

    else if (this.widgetDetail.chart_type == 'customlinearea') {
      // console.log(selectedColor,"colorclick")
      // console.log(options.series[0].itemStyle)
      options.series[0].itemStyle.color = selectedColor[0];
      // console.log(options.series[0].itemStyle,"after")

      options.series[1].itemStyle.color = selectedColor[5];
      myChart.setOption(options);
      this.chartOption = options;
    }

    else if (this.widgetDetail.chart_type == 'treemap') {
      const sc = [...selectedColor];
      // options.series[0].levels[0].color = sc.reverse()
      options.series[0].levels[0].color = sc
      myChart.setOption(options);
      this.chartOption = options;
    }
    else if(this.widgetDetail.chart_type== 'polar_tangential_bar'){
      
      const sc = [...selectedColor];
      options.color = sc
      options.series[0].itemStyle = {
        color: function (params) {
          let colors = sc;
            return colors[params.dataIndex % colors.length]; // Cycle through colors
        }
    };
      
      myChart.setOption(options,true);

      this.chartOption = options;
      
    }
    else {
      myChart.setOption({
        color: selectedColor
      });
    }

    // this is to update the chartoption object, so that it will be reflected in fullscreen
    if (selectedColor) this.chartOption.color = selectedColor
    this.selectedColorPalette = selectedColor; // store selected color apply again after date filter is applied
  }


  setChartColor(selectedColor) {
    if (this.widgetDetail.chart_type == 'custompolarheatmap' || this.widgetDetail.chart_type == 'heatmap' || this.widgetDetail.chart_type == 'custompolarheatmap2') {
      // selectedColor = ['#FFFFFF'].concat(selectedColor);
      this.chartOption.visualMap.inRange.color = selectedColor;
    }
      else if (this.widgetDetail.chart_type == 'polarbar') {
      this.chartOption.series[1].itemStyle.color = selectedColor[5];
      this.chartOption.series[3].itemStyle.color = selectedColor[3];
    }
    else if (this.widgetDetail.chart_type == 'large_area_chart') {
      this.chartOption.series[0].itemStyle.color = selectedColor[0];
      // this.chartOption.series[0].areaStyle.color = new echarts.graphic.LinearGradient(0, 0, 0, 1, [
      //   {
      //     offset: 0,
      //     color: selectedColor[2]
      //   },
      //   {
      //     offset: 1,
      //     color: selectedColor[0]
      //   }
      // ])
      this.chartOption.series[0].areaStyle.color = selectedColor[1];
    }
    else if (this.widgetDetail.chart_type == 'customlinearea') {
//console.log(selectedColor,"color")

      this.chartOption.series[0].itemStyle.color = selectedColor[0];

      this.chartOption.series[1].itemStyle.color = selectedColor[5];
    }
    else if (this.widgetDetail.chart_type == 'treemap') {
      const sc = [...selectedColor];
      // this.chartOption.series[0].levels[0].color = sc.reverse()
      this.chartOption.series[0].levels[0].color = sc
    }
    else if(this.widgetDetail.chart_type== 'polar_tangential_bar'){
      // console.log("setChartColor=========",this.chartOption)
      const sc = [...selectedColor];
      this.chartOption.series.itemStyle.color = function (params) {
        // Custom colors for each bar
        let colors = sc;
        return colors[params.dataIndex % colors.length]; // Assign colors dynamically
      }
    
    }
  
      else {
        this.chartOption.color = selectedColor
      }
  }

  //open full screen option
  fullscreen_click(header, body, subTitle): void {
    // subTitle = ''
    if (!this.handledashboardwidgetnodata.status) {
      this.matDialog.open(DialogBoxComponent, {
        width: this.dialogWidth,
        height: '80vh',
        data: {
          template: body,
          head: header,
          subHead: subTitle,
        }
      });
    }
  }
  //download table/chart data option
  download_click(chart): void {
    // console.log(chart)
    if (!this.handledashboardwidgetnodata.status) {
      this.moreOptionState = false; //close the moreoption div before downloading
      this.cdf.detectChanges(); // it stop executing the next lines untill the change is ddtected

      if (this.widgetType == "Table") {
        let date="DATE : "+this.timeZoneService.getcurrentuserTime().format("DD-MM-YYYY")+"\n"+"TIME : "+this.timeZoneService.getcurrentuserTime().format("hh:mm:ss")
        const fileName = this.widgetDetail.widgetName+"_"+this.timeZoneService.getcurrentuserTime().format("DDMMYYYY")+".pdf"

        const PDF = new jsPDF('portrait', 'px', 'a4') as jsPDFWithPlugin;
        PDF.addFileToVFS('Metropolis-ExtraLight.ttf', Metropolis_ExtraLight);
        PDF.addFileToVFS('Metropolis-Light.ttf', Metropolis_Light);
        PDF.addFileToVFS('Metropolis-LightItalic.ttf', Metropolis_LightItalic);
        PDF.addFileToVFS('Metropolis-Medium.ttf', Metropolis_Medium);
        PDF.addFileToVFS('Metropolis-Regular.ttf', Metropolis_Regular);
        PDF.addFileToVFS('Metropolis-SemiBold.ttf', Metropolis_SemiBold);
        PDF.addFont('Metropolis-Regular.ttf', 'metropolis', 'normal');
        PDF.addFont('Metropolis-Light.ttf', 'metropolis', 'light');
        PDF.addFont('Metropolis-SemiBold.ttf', 'metropolis', 'bold');
        PDF.setFontSize(15)
        PDF.setTextColor('#0A4143')
        PDF.setFont('metropolis','normal')
        PDF.text(this.widgetDetail.title,26,20)
        PDF.setFontSize(9)
        PDF.setTextColor('#0A4143')
        PDF.setFont('metropolis','light')
        // PDF.text(this.widgetDetail.timeRange[0]+' - '+this.widgetDetail.timeRange[1],6,25)
        PDF.text(this.CustomFilterSub,26,30)
        PDF.setFontSize(9)
        PDF.setTextColor('#0A4143')
        PDF.setFont('metropolis','normal')
        PDF.text(date,350,20)
        let position = 50;

        // PDF.autoTable({
        //   startY:position,
        //   theme: 'plain',
        //   headStyles: { fillColor: '#E8E8E8' },
        //   head: [this.widgetDetail.tableHeaders],
        //   body: this.widgetDetail.tableRows.map(Object.values)
        // });

        PDF.autoTable({
          head: [this.widgetDetail.tableHeaders],
          body: this.widgetDetail.tableRows.map(Object.values),
          startY:position,
          
          headStyles: {
            font: 'metropolis',
            // fillColor: "white",
            fillColor:"#f1f6f8",
            fontSize: 12,
            // textColor: "#0A4143"
            textColor:"#48454a",
            minCellWidth:10
          },
          styles: {
            font: 'metropolis',
            // cellPadding:2,
            fontSize: 10,
            cellWidth: "auto",
            // textColor: "gray",
            textColor:"#48454a",
            cellPadding:{
              "top":3,
              "bottom":3
            }
            
            // lineWidth: 1
            // lineWidth: 0.2,
            // lineColor: [0, 0, 0]
          },
          
          alternateRowStyles: {
            fillColor: "white"
          },
          didDrawCell(data) {
            const { cell, row, table } = data;
        
            // if (data.section === 'body') {
              const x = cell.x;
              const y = cell.y + cell.height;
              const width = cell.width;
        
              PDF.setLineWidth(1);
              PDF.line(x, y, x + width, y);
            // }
          },
          
          // tableLineWidth: 0.2,
          // tableLineColor: [0, 0, 0]
        });
        PDF.save(fileName);
      }
      else {
        let DATA: any = document.getElementById(this.widgetName+'htmlwidget'); //full widget with title and more filter imagej 
        // console.log({DATA})
        let date="DATE : "+this.timeZoneService.getcurrentuserTime().format("DD-MM-YYYY")+"\n"+"TIME : "+this.timeZoneService.getcurrentuserTime().format("hh:mm:ss")
        const fileName = this.widgetDetail.widgetName+"_"+this.timeZoneService.getcurrentuserTime().format("DDMMYYYY")+".pdf"

        html2canvas(DATA).then((canvas) => {
          let fileWidth = 200;
          let fileHeight = (canvas.height * fileWidth) / canvas.width;
          const FILEURI = canvas.toDataURL('image/png');
          let PDF = new jsPDF('p', 'mm', 'a4');
          PDF.addFileToVFS('Metropolis-ExtraLight.ttf', Metropolis_ExtraLight);
          PDF.addFileToVFS('Metropolis-Light.ttf', Metropolis_Light);
          PDF.addFileToVFS('Metropolis-LightItalic.ttf', Metropolis_LightItalic);
          PDF.addFileToVFS('Metropolis-Medium.ttf', Metropolis_Medium);
          PDF.addFileToVFS('Metropolis-Regular.ttf', Metropolis_Regular);
          PDF.addFileToVFS('Metropolis-SemiBold.ttf', Metropolis_SemiBold);
          PDF.addFont('Metropolis-Regular.ttf', 'metropolis', 'normal');
          PDF.addFont('Metropolis-Light.ttf', 'metropolis', 'light');
          PDF.addFont('Metropolis-SemiBold.ttf', 'metropolis', 'bold');
          PDF.setFontSize(15)
          PDF.setTextColor('#0A4143')
          PDF.setFont('metropolis','normal')
          PDF.text(this.widgetDetail.title,9,20)
          PDF.setFontSize(9)
          PDF.setTextColor('#0A4143')
          PDF.setFont('metropolis','light')
          // PDF.text(this.widgetDetail.timeRange[0]+' - '+this.widgetDetail.timeRange[1],6,25)
          PDF.text(this.CustomFilterSub,10,25)
          PDF.setFontSize(9)
          PDF.setTextColor('#0A4143')
          PDF.setFont('metropolis','normal')
          PDF.text(date,170,20)
          let position = 50;
          PDF.addImage(FILEURI, 'PNG', 5, position, fileWidth, fileHeight);
          PDF.save(fileName);
        });
      }
    }
  }

  // customSubtitle(sub: string, fromdate, todate, numDays) {

  //   if (sub) {
  //     sub = ""
  //     switch (true) {
  //       case (numDays == undefined || (fromdate && todate)):
  //         this.CustomFilterSub = sub + ` ` + `custom   ( ${formatDate(fromdate, 'd MMM', 'en-US')}  to  ${formatDate(todate, 'd MMM', 'en-US')} )`;
  //         break;
  //       case (numDays == 1):
  //         this.CustomFilterSub = sub + ` ` + ` yesterday` + `   ( ${formatDate(fromdate, 'd MMM', 'en-US')}  to  ${formatDate(todate, 'd MMM', 'en-US')} )`;
  //         break;
  //       case (numDays == 0):
  //         this.CustomFilterSub = sub + ` ` + ` today` + `   ( ${formatDate(fromdate, 'd MMM', 'en-US')}  to  ${formatDate(todate, 'd MMM', 'en-US')} )`;
  //         break;
  //       default:
  //         this.CustomFilterSub = sub + ` ` + ` past ${numDays + 1} days` + `   ( ${formatDate(fromdate, 'd MMM', 'en-US')}  to  ${formatDate(todate, 'd MMM', 'en-US')} )`;
  //     }

  //   }
  //   // this.CustomFilterSub = ''
  // }

  customSubtitle(sub: string, fromdate, todate, numDays) {

    if (sub) {
      sub = ""
      let format = 'D MMM'
      switch (true) {
        case (numDays == undefined || (fromdate && todate)):
          // this.CustomFilterSub = sub + ` ` + `custom   ( ${formatDate(fromdate, 'd MMM', 'en-US')}  to  ${formatDate(todate, 'd MMM', 'en-US')} )`;
          this.CustomFilterSub = sub + ` ` + `custom   ( ${this.timeZoneService.toUserTimeZone(fromdate).format(format)}  to  ${this.timeZoneService.toUserTimeZone(todate).format(format)} )`;

          break;
        case (numDays == 1):
          this.CustomFilterSub = sub + ` ` + ` yesterday` + `   ( ${this.timeZoneService.toUserTimeZone(fromdate).format(format)}  to  ${this.timeZoneService.toUserTimeZone(todate).format(format)} )`;
          break;
        case (numDays == 0):
          this.CustomFilterSub = sub + ` ` + ` today` + `   ( ${this.timeZoneService.toUserTimeZone(fromdate).format(format)}  to  ${this.timeZoneService.toUserTimeZone(todate).format(format)} )`;
          break;
        default:
          this.CustomFilterSub = sub + ` ` + ` past ${numDays + 1} days` + `   ( ${this.timeZoneService.toUserTimeZone(fromdate).format(format)}  to  ${this.timeZoneService.toUserTimeZone(todate).format(format)} )`;
      }

    }
    // this.CustomFilterSub = ''
  }
  format_axiz_lable(option,chart_type:string,isdatacolbyte) {
    let temp_option = {}
    if ('yAxis' in option && 'type' in option['yAxis'] && option['yAxis']['type'] == 'value') {
     
        temp_option = {
          ...option, ...{
            'yAxis': {
              'axisLabel': {
                'formatter': isdatacolbyte?this.dashboardService.getFormaterSize():this.dashboardService.getFormaterFunction(chart_type)
              }
            }
          }
        }
     
      
      return temp_option
    }
    else if ('angleAxis' in option && 'type' in option['angleAxis'] && option['angleAxis']['type'] == 'value') {
     
      temp_option = {
        ...option, ...{
          'angleAxis': {
            'axisLabel': {
              'formatter': isdatacolbyte?this.dashboardService.getFormaterSize():this.dashboardService.getFormaterFunction(chart_type)
            },
            'axisLine': {
              'lineStyle': {
                'opacity': 0.2
              }
            }
          }
        }
      }
      return temp_option;
    }
    else if ('xAxis' in option && 'type' in option['xAxis'] && option['xAxis']['type'] == 'value') {
      temp_option = {
        ...option, ...{
          'xAxis': {
            'axisLabel': {
              'formatter': isdatacolbyte?this.dashboardService.getFormaterSize():this.dashboardService.getFormaterFunction(chart_type)
            }
          }
        }
      }
      return temp_option;
    }
    else return option;
  }
  setWidgetDetails(widgetdetails: any) {
//console.log(widgetdetails)
//console.log("Widget Details")
    if (widgetdetails && widgetdetails.hasOwnProperty('widgetDetails')) {
      if (this.widgetType == 'Chart') {
        this.chartOption = {};
        this.widgetDetail = widgetdetails.widgetDetails;
        // this.customSubtitle(this.widgetDetail.subTitle, this.timeRange.controls.fromDate.value, this.timeRange.controls.toDate.value, this.filterDays)
        // if (this.widgetDetail.apply_default_timerange) {
          // if(!this.CustomFilterSub){
            if(!this.isCollectiveDashboard){
            this.customSubtitle(this.widgetDetail.subTitle, this.timeRange.controls.fromDate.value, this.timeRange.controls.toDate.value, this.filterDays)
            }else{

            
            // console.log("FilterDays-->",this.filterDays)
            this.customSubtitle(this.widgetDetail.subTitle, this.widgetDetail.timeRange[0], this.widgetDetail.timeRange[1], this.widgetDetail.noOfDays)
          }
        // } else {
        //   console.log("Custom Filter",this.CustomFilterSub)
          
          // this.CustomFilterSub = this.widgetDetail.subTitle;
        //   console.log(this.widgetDetail.subTitle)
        //   console.log(this.CustomFilterSub)
        //   // this.CustomFilterSub =''
        // }
        if (this.widgetDetail.isData) {
          
          this.chartOption = this.format_axiz_lable(this.widgetDetail.chartOption,this.widgetDetail.chart_type,this.widgetDetail.isdatacolbyte);
          if (this.widgetDetail.chart_type == 'customlinearea') {
            if (this.widgetDetail.isdatacolbyte == 2){
              this.chartOption.tooltip['formatter'] = this.dashboardService.getTooltipFormater(this.widgetDetail.chart_type,this.widgetDetail.isdatacolbyte)

            }
              this.chartOption.tooltip['formatter'] = this.dashboardService.getTooltipFormater(this.widgetDetail.chart_type,this.widgetDetail.isdatacolbyte)
//console.log(this.chartOption,"options")
//console.log(this.widgetDetail.isdatacolbyte,"iscol")
            }
         
          else{
            this.chartOption.tooltip['formatter'] = this.dashboardService.getTooltipFormater(this.widgetDetail.chart_type,this.widgetDetail.isdatacolbyte)

          }
          if (this.selectedColorPalette) {
            this.setChartColor(this.selectedColorPalette);
            // console.log("Palette",this.setChartColor)
          } else {
            this.setChartColor(this.widgetDetail.colors);
            // console.log("Widget",this.setChartColor)

          }
          this.spinnerState = false;
          // console.log("setWidgetDetails==",this.widgetDetail)
          if (this.widgetDetail.chart_type == 'pie') {
            if (this.widgetDetail.chartData) this.chartOption.series[0].data = this.widgetDetail.chartData;
            else this.chartOption.series[0].data = [];


          } else if (this.widgetDetail.chart_type == 'line') {
            if (this.widgetDetail.chartData) {

              let alertcountchartinfo = this.dashboardService.getAlertCountChartdata(this.widgetDetail.chartData['data'])
              this.chartOption.xAxis.data = alertcountchartinfo['alert_days'];
              this.chartOption.series[0]['data'] = alertcountchartinfo['alert_cnt'];
            }
          } else if (this.widgetDetail.chart_type == 'custompolarheatmap') {

            if (this.widgetDetail.chartData) {

              let addchartinfo = this.dashboardService.getCustomPolarHeatmapChartdata(this.widgetDetail.chartData['data']);
              this.chartOption.visualMap.max = addchartinfo['maxvalue'];
              this.chartOption.series[0].renderItem = addchartinfo['renderitem'];
              this.chartOption.angleAxis.data = this.widgetDetail.chartData['hours'];
              this.chartOption.radiusAxis.data = addchartinfo['days'];
              this.chartOption.series[0].data = addchartinfo['data'];
              this.chartOption.tooltip.formatter = this.dashboardService.getcustomPolarheatmapChartformatter(addchartinfo['days'], addchartinfo['data']);

            }
          } else if (this.widgetDetail.chart_type == 'custompolarheatmap2') {
            this.chartOption.series[0].renderItem = this.dashboardService.getCustomPolarHeatmap2formatter();
            this.chartOption.tooltip.formatter = this.dashboardService.getcustomPolarheatmap2tooltipformatter(this.chartOption.radiusAxis.data, this.chartOption.angleAxis.data, this.chartOption.series[0].data);
          } else if (this.widgetDetail.chart_type == 'polarbar') {
            if (this.widgetDetail.chartData) {
              if (this.widgetDetail.chartData['data']) {
                this.chartOption.angleAxis.data = this.widgetDetail.chartData['eventids'];
                this.chartOption.tooltip.formatter = this.dashboardService.getPolarBarChartformatter(this.widgetDetail.chartData['data'], this.widgetDetail.chartData['eventids']);
                this.chartOption.series = this.dashboardService.getPolarBarChartSeries(this.chartOption.series, this.widgetDetail.chartData['data']);
              }
            }
          } else if (this.widgetDetail.chart_type == 'treemap') {
            if (this.widgetDetail.chartData) {
              let formaterfn = this.dashboardService.getTreemapChartformater();
              this.chartOption.tooltip.formatter = formaterfn;
              this.chartOption.series[0].data = this.widgetDetail.chartData;
            }
          } else if(this.widgetDetail.chart_type == 'gauge-grade'){
            const val = this.chartOption.series[0].data[0].value
            // let formaterfn = this.dashboardService.getGaugeGradeFormater();
            // this.chartOption.series[0].axisLabel.formatter = formaterfn
            this.chartOption.series[0].detail.formatter = this.dashboardService.getGaugeGradeValueFormater(val)  
            
          } else if(this.widgetDetail.chart_type == 'polar_tangential_bar'){
                       
          } else if(this.widgetDetail.chart_type == 'donut' || this.widgetDetail.chart_type == 'simple_pie'|| this.widgetDetail.chart_type == 'nightingale'){
            let formaterfn = this.dashboardService.legentFormaterFuncation(this.chartOption.series[0].data,this.widgetDetail.isdatacolbyte);
            this.chartOption.legend.formatter = formaterfn
          }else if(this.widgetDetail.chart_type == 'polar_radial_bar'){
            if(this.widgetDetail.isdatacolbyte == 1){
              let formaterfn = this.dashboardService.sizeFormater();
              let tooltipformaterfn = this.dashboardService.tooltipsizeFormater();

              this.chartOption.radiusAxis.axisLabel.formatter = formaterfn
              this.chartOption.tooltip.formatter = tooltipformaterfn
            }
            else{
              let formaterfn = this.dashboardService.getFormaterFunction(this.widgetDetail.chart_type);
              // let tooltipformaterfn = this.dashboardService.areaStacktooltipsizeFormater();

              this.chartOption.radiusAxis.axisLabel.formatter = formaterfn
            }
          } else if(this.widgetDetail.chart_type == 'areaStack' || this.widgetDetail.chart_type == 'lineStack' ){
            if(this.widgetDetail.isdatacolbyte == 1){
              let formaterfn = this.dashboardService.sizeFormater();
              let tooltipformaterfn = this.dashboardService.areaStacktooltipsizeFormater();

              this.chartOption.yAxis[0].axisLabel.formatter = formaterfn
              this.chartOption.tooltip.formatter = tooltipformaterfn
            }
            else if(this.widgetDetail.isdatacolbyte == 0){
              let formaterfn = this.dashboardService.getFormaterFunction(this.widgetDetail.chart_type);
              let tooltipformaterfn = this.dashboardService.areaStacktooltipNumberFormater();

              this.chartOption.yAxis[0].axisLabel.formatter = formaterfn
              this.chartOption.tooltip.formatter = tooltipformaterfn
            }
            
          } else if(this.widgetDetail.chart_type == 'barStack'){
            if(this.widgetDetail.isdatacolbyte == 1){
              let formaterfn = this.dashboardService.sizeFormater();
              let tooltipformaterfn = this.dashboardService.barStackTooltipSizeFormatter();

              this.chartOption.yAxis[0].axisLabel.formatter = formaterfn
              this.chartOption.tooltip.formatter = tooltipformaterfn
              console.log(this.chartOption)
            }
            else if(this.widgetDetail.isdatacolbyte == 0 || this.widgetDetail.isdatacolbyte === null){
              let formaterfn = this.dashboardService.getFormaterFunction(this.widgetDetail.chart_type);
              let tooltipformaterfn = this.dashboardService.barStackTooltipNumberFormatter();

              this.chartOption.yAxis[0].axisLabel.formatter = formaterfn
              this.chartOption.tooltip.formatter = tooltipformaterfn
            }
          }
        } else {
          this.spinnerState = false;
          this.handledashboardwidgetnodata.seterror(true, this.sharedService.metaData.alert.noDatamsg[1])
        }

      } else if (this.widgetType == 'Table') {
        this.widgetDetail = widgetdetails.widgetDetails
        // console.log("setWidgetDetails==",this.widgetDetail)
        this.spinnerState = false;
        this.widgetDetail.tableRows = this.widgetDetail.tableRows?this.widgetDetail.tableRows:[]
        for(let i=0;i<this.widgetDetail.tableRows.length;i++){
          if(this.widgetDetail.tableRows[i].hasOwnProperty("count")){
            this.widgetDetail.tableRows[i]["count"] = this.dashboardService.tableFormateNumber(this.widgetDetail.tableRows[i]["count"])
          }
          if(this.widgetDetail.tableRows[i].hasOwnProperty("count_difference")){
            this.widgetDetail.tableRows[i]["count_difference"] = this.dashboardService.tableFormateNumber(this.widgetDetail.tableRows[i]["count_difference"])
          }

        }

        if(!this.isCollectiveDashboard){
          this.customSubtitle(this.widgetDetail.subTitle, this.timeRange.controls.fromDate.value, this.timeRange.controls.toDate.value, this.filterDays)
          }else{

          
          // console.log("FilterDays-->",this.filterDays)
          this.customSubtitle(this.widgetDetail.subTitle, this.widgetDetail.timeRange[0], this.widgetDetail.timeRange[1], this.widgetDetail.noOfDays)
        }
        // this.customSubtitle(this.widgetDetail.subTitle, this.timeRange.controls.fromDate.value, this.timeRange.controls.toDate.value, this.filterDays)
        // if (this.widgetDetail.apply_default_timerange) {
          // if(!this.CustomFilterSub){
            // this.customSubtitle(this.widgetDetail.subTitle, this.timeRange.controls.fromDate.value, this.timeRange.controls.toDate.value, this.filterDays)
            // this.customSubtitle(this.widgetDetail.subTitle, this.widgetDetail.timeRange[0], this.widgetDetail.timeRange[1], this.widgetDetail.noOfDays)
//             console.log("2nd",this.CustomFilterSub)
//           // }
// //console.log(this.CustomFilterSub,"===========")
          
//         } else {
//           // console.log("2nd",this.CustomFilterSub)
//           this.CustomFilterSub = this.widgetDetail.subTitle;
//           console.log(this.CustomFilterSub)
//           // this.CustomFilterSub = ''
//         }
        if (!this.widgetDetail.isData) {
          this.handledashboardwidgetnodata.seterror(true, this.sharedService.metaData.alert.noDatamsg[1])
        }
      }
    } else if (widgetdetails && widgetdetails.hasOwnProperty('isError') && widgetdetails.hasOwnProperty('error')) {
      this.setErrormsg(widgetdetails)
    }

  }

  setErrormsg(err) {
    this.spinnerState = false;
    this.errorhandledashboardwidget.seterror(true, err.error?.errmsg);
  }


  ngOnDestroy() {
    if (this.previewRef) this.previewRef.close();
    if (this.dialogRef) this.dialogRef.close();
    if (!this.defaultState) {
      this.widgetrequestinstance.cancelRequest();
    }
    this.$destroy.next(true)
    this.$destroy.unsubscribe()
  }

} 